import React, { useEffect } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { useState, useRef } from "react";
import { mainTable } from "../css/Common";
import TextArea from "../ReusableComponents/TextArea";
import Image1 from "../image/Image1.jpeg";
import { BindAPI } from "../services/APIConnection";
import Checkbox from "../ReusableComponents/Checkbox";
import toast from "react-hot-toast";
import { IUDAPI, BindPostAPI } from "../services/APIConnection";
import { useNavigate } from "react-router-dom";
const OnLostPopUp = ({ data, data1, isOpen, isSubmit }) => {
  //

  const [tableData, setTableData] = useState([]);
  const [lostreasondropdown, setlostreasondropdown] = useState([]);
  const navigate = useNavigate();
  var clientId = sessionStorage.getItem("MstClientId");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [lostFormData, setLostFormData] = useState([
    {
      fname: "",
      lname: "",
      number: "",
      lostnotes: "",
      reasonforlost: ""
    }
  ]);

  const [selectedRooms, setSelectedRooms] = useState([]);
  const [TxnEnquiryId, setTxnEnquiryId] = useState("");
  const createdBy = sessionStorage.getItem("createdBy");

  // Errors
  const [error, setErrors] = useState([]);

  // Set initial table data and form structure
  useEffect(() => {
    if (data1?.length > 0) {
      setTableData(data1);

      const initialForm = data1.map(() => ({
        reasonforlost: "",
        lostnotes: "",
      }));
      setLostFormData(initialForm);

      const initialErrors = data1.map(() => ({
        reasonforlost: "",
        lostnotes: "",
      }));
      setErrors(initialErrors);
    }
  }, [data1]);

  // Set selected rooms as empty arrays per row
  useEffect(() => {
    setSelectedRooms(tableData.map(() => []));
  }, [tableData]);

  // Fetch dropdown options
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    if (response && response.data) {
      const LostReasonId = response.data.Table8.map((item) => ({
        value: item.MstLostReasonId,
        label: item.LostReason,
      }));
      setlostreasondropdown(LostReasonId);
    }
  };

  // Handle change in dropdown or notes per row
  // ✅ Universal Input Change Handler
  const handleDropdownChange = (index, event) => {
    const { value } = event.target;

    setLostFormData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        reasonforlost: value,
      };
      return updated;
    });
  };

  const handleNotesChange = (event) => {
    const { name, value } = event.target;

    setLostFormData((prev) => {
      const updated = [...prev];
      updated[0] = {
        ...updated[0],
        [name]: value,
      };
      return updated;
    });
  };

  // Handle checkboxes
  // const handleToggleRoom = (roomIndex, roomNumber) => {
  //   setSelectedRooms((prev) => {
  //     const updated = [...prev];
  //     const current = updated[roomIndex] || [];
  //     if (current.includes(roomNumber)) {
  //       updated[roomIndex] = current.filter((num) => num !== roomNumber);
  //     } else {
  //       updated[roomIndex] = [...current, roomNumber];
  //     }
  //     return updated;
  //   });
  // };
  const handleToggleRoom = (roomIndex, roomNumber) => {
    setSelectedRooms((prev) => {
      const updated = [...prev];
      const current = updated[roomIndex] || [];
      if (current.includes(roomNumber)) {
        updated[roomIndex] = current.filter((num) => num !== roomNumber);
      } else {
        updated[roomIndex] = [...current, roomNumber];
      }
      return updated;
    });
  };
  

  const handleSelectAll = (roomIndex, totalRooms) => {
    setSelectedRooms((prev) => {
      const updated = [...prev];
      updated[roomIndex] = Array.from({ length: totalRooms }, (_, i) => i + 1);
      return updated;
    });
  };

  const handleUnselectAll = (roomIndex) => {
    setSelectedRooms((prev) => {
      const updated = [...prev];
      updated[roomIndex] = [];
      return updated;
    });
  };

  const handleBlur = (index, e) => {
    if (!e?.target) return;

    const { name, value } = e.target;
    const label = name === "reasonforlost" ? "Reason for Lost" : "Notes";
    const message =
      value.trim() === ""
        ? name === "reasonforlost"
          ? `Select ${label}`
          : `Enter ${label}`
        : "";

    setErrors((prev) => {
      const updated = [...prev];
      updated[index][name] = message;
      return updated;
    });
  };

  // const validateForm = () => {
  //   let valid = true;
  //   const newErrors = lostFormData.map((data, index) => {
  //     const err = {};
  //     if (!data.reasonforlost || data.reasonforlost.trim() === '') {
  //       err.reasonforlost = 'Select Reason for Lost';
  //       valid = false;
  //     }
  //     return err;
  //   });
  //   setErrors(newErrors);
  //   return valid;
  // };

  // Enhanced validation function
  const validateForm = () => {
    let valid = true;
    const newErrors = [];

    // Check if at least one room is selected across all room types
    const hasSelectedRooms = selectedRooms.some(roomArray => roomArray.length > 0);

    if (!hasSelectedRooms) {
      toast.error("Please select at least one room to mark as lost", {
        duration: 3000,
        position: "top-center",
      });
      valid = false;
      return valid;
    }

    // Validate reason for lost ONLY for room types that have selected rooms
    tableData.forEach((room, index) => {
      const err = {};
      const hasRoomsSelected = selectedRooms[index]?.length > 0;

      if (hasRoomsSelected) {
        // Only validate reason dropdown if this room type has selected rooms
        if (!lostFormData[index]?.reasonforlost || lostFormData[index].reasonforlost.trim() === '') {
          err.reasonforlost = 'Please select reason for lost rooms';
          toast.error('Please select reason for lost rooms', {
            duration: 3000,
            position: "top-center",
          });
          valid = false;
        }
      }

      newErrors[index] = err;
    });

    setErrors(newErrors);
    return valid;
  };

  const handleSubmitLost = async (flag) => {
    
    const isValid = validateForm();
    if (flag !== 2 || !isValid) return;


    setSubmitBtnDisabled(true)
    let allSuccess = true;
    // Determine if ALL rooms in ALL room types are selected
    const allSelected = tableData.every((room, index) => {
      return selectedRooms[index]?.length === room.NoOfRequiredRooms;
    });

    const mstStatusId = allSelected ? 3 : 2;

    for (let index = 0; index < tableData.length; index++) {
      const room = tableData[index];
      const selectedCount = selectedRooms[index]?.length || 0;

      if (selectedCount > 0) {
        const payload = {
          txnEnquiryId: room.TxnEnquiryId || 0,
          mstRoomTypeId: room.RoomTypeId,
          roomNo: selectedCount,
          mstLostReasonId: lostFormData[index]?.reasonforlost || "",
          lostReasonNotes: lostFormData[0]?.lostnotes || "",
          mstEnquiryStatusId: mstStatusId,
          createdBy: Number(createdBy),
          flag: flag,
        };

        console.log(payload);
        try {
          const response = await IUDAPI(payload, "Enquiry/IUDLostEnquiry");
          if (response.data?.Table?.[0]?.Result !== "M") {
            allSuccess = false;
          }
        } catch (err) {
          allSuccess = false;
          console.error(
            `Failed to update for RoomTypeId ${room.RoomTypeId}:`,
            err
          );
        }
      }
    }

    if (allSuccess) {

      toast.success("Submitted successfully 👍", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      toast.error("Some room entries failed to update 👎", {
        duration: 3000,
        position: "top-center",
      });
    }

    setTimeout(handleCancel, 3000);
    navigate("/enquirylost");

    handleCancel()
  };


  const handleCancel = () => {
    
    isOpen(false);
    setSubmitBtnDisabled(false)
    // isSubmit(true);
  };
  return (
    <>
      <div className="mx-auto p-8 maxw-7xl">
        <div className={mainTable.grid3}>
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryid"
            content={data?.enquiryid || ""}
            disabled={true}
            // tabIndex="11"
            isRequired={true}
            errorMessage={error.enquiryid}
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="fromdate"
            content={data?.fromdate || ""}
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking To"
            name="todate"
            content={data?.todate || ""}
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="First Name"
            name="fname"
            content={data?.fname || ""}
            disabled={true}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lname"
            content={data?.lname || ""}
            disabled={true}
            // tabIndex="2"
            isRequired={true}
          // classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="number"
            content={data?.number || ""}
            disabled={true}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
          />
        </div>

        <TextArea
          title="Notes"
          name="lostnotes"
          placeholder="Describe here"
          rows="3"
          controlFunc={handleNotesChange}
          isRequired={true}
        />
      </div>

      {/* Room List Section */}
      <div className="mx-auto p-4 max-w-7xl">
        <ul className="space-y-4">
          {tableData?.map((room, index) => (
            <li
              key={index}
              className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
            >
              <div className="flex flex-col items-start justify-between">
                <label className="flex items-center gap-4">
                  <input
                    type="checkbox"
                    checked={
                      selectedRooms[index]?.length === room.NoOfRequiredRooms
                    }
                    onChange={(e) => {
                      e.target.checked
                        ? handleSelectAll(index, room.NoOfRequiredRooms)
                        : handleUnselectAll(index);
                    }}
                  />
                  Select All
                </label>

                <h2 className="text-lg font-semibold text-gray-800 mb-2">
                  {room.RoomName}
                </h2>

                <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                  <img
                    src={room.Photo}
                    alt="Room"
                    className="h-48 w-36 object-cover rounded-md border"
                  />

                  <div className="flex-1 flex-col w-full">
                    <div className="flex flex-col md:flex-row md:gap-x-12 flex-1">
                      {/* Room Details */}
                      <div className="space-y-1">
                        <p className="text-sm font-semibold text-gray-600">
                          Room Details
                        </p>
                        <p className="text-sm text-gray-600">
                          Property Size: {room.Size}
                        </p>
                        <p className="text-sm text-gray-600">
                          Max Occupancy: {room.MaxOccupancy}
                        </p>
                        <p className="text-sm text-gray-600">
                          Villa Type: {room.RoomType}
                        </p>
                      </div>

                      {/* Space Details */}
                      <div className="space-y-1">
                        <p className="text-sm font-semibold text-gray-600">
                          Space Details
                        </p>
                        {room.SpaceDetails ? (
                          <ul className="text-sm text-gray-600">
                            {room.SpaceDetails.split(",").map((item, idx) => (
                              <li key={idx}>
                                {idx + 1}. {item.trim()}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-sm text-gray-600">Not Available</p>
                        )}
                      </div>

                      {/* Amenities */}
                      <div className="space-y-1">
                        <p className="text-sm font-semibold text-gray-600">
                          Amenities
                        </p>
                        {room.AmenitiesDetails ? (
                          <ul className="text-sm text-gray-600">
                            {room.AmenitiesDetails.split(",").map(
                              (item, idx) => (
                                <li key={idx}>
                                  {idx + 1}. {item.trim()}
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          <p className="text-sm text-gray-600">Not Available</p>
                        )}
                      </div>
                    </div>

                    {/* Room selection and reason */}
                    <div className="flex flex-row justify-between gap-8 mt-4">
                      <div className="flex flex-col gap-2">
                        <p className="text-sm font-semibold text-gray-700">
                          Rooms: {room.NoOfRequiredRooms}
                        </p>
                        <div className="flex gap-2 flex-wrap">
                          {/* {(room.AvailableRoomsName || "")
        .split(",")
        .filter(name => name.trim() !== "") // safety
        .map((roomName, idx) => {
          const trimmedName = roomName.trim();
          const isChecked = selectedRooms[index]?.includes(trimmedName);

          return (
            <label key={idx} className="cursor-pointer">
              <input
                type="checkbox"
                className="hidden peer"
                checked={isChecked}
                onChange={() => handleToggleRoom(index, trimmedName)}
              />
              <span
                className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white ${
                  isChecked
                    ? "bg-red-800"
                    : "bg-green-500 hover:bg-green-600"
                }`}
              >
                {trimmedName}
              </span>
            </label>
          );
        })} */}
                          {/* {Array.from(
                            { length: room.NoOfRequiredRooms },
                            (_, idx) => {
                              const number = idx + 1;
                              const isChecked =
                                selectedRooms[index]?.includes(number);
                              return (
                                <label key={idx} className="cursor-pointer">
                                  <input
                                    type="checkbox"
                                    className="hidden peer"
                                    checked={isChecked}
                                    onChange={() =>
                                      handleToggleRoom(index, number)
                                    }
                                  />
                                  <span
                                    className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white ${isChecked
                                        ? "bg-red-800"
                                        : "bg-green-500 hover:bg-green-600"
                                      }`}
                                  >
                                    {number}
                                  </span>
                                </label>
                              );
                            }
                          )} */}
                            {Array.from(
                      { length: room.NoOfRequiredRooms },
                      (_, idx) => {
                        const roomNumber = idx + 1;
                        const isChecked = selectedRooms[index]?.includes(roomNumber);
                        const label = `${room.RoomName || room.RoomType} ${roomNumber}`;
                        
                        return (
                          <label key={idx} className="cursor-pointer">
                            <input
                              type="checkbox"
                              className="hidden peer"
                              checked={isChecked}
                              onChange={() => handleToggleRoom(index, roomNumber)}
                            />
                            <span
                              className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white ${
                                isChecked
                                  ? "bg-red-800"
                                  : "bg-green-500 hover:bg-green-600"
                              }`}
                            >
                              {label}
                            </span>
                          </label>
                        );
                      }
                    )}
                        </div>
                      </div>

                      {/* Dropdown */}
                      <div className="text-gray-900 text-sm rounded-lg">
                        <div className={mainTable.grid3}>
                          <DropDown
                            name="reasonforlost"
                            title="Reason for Lost"
                            type="select-one"
                            options={lostreasondropdown}
                            selectedOption={
                              lostFormData[index]?.reasonforlost || ""
                            }
                            controlFunc={(e) => handleDropdownChange(index, e)}
                            controlFuncBlur={(e) => handleBlur(index, e)}
                            placeholder="Select reason"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Footer Buttons */}
      <div className="h-28 flex justify-center items-center gap-4">
        <button
          type="button"
          className={mainTable.submitButton}
          onClick={() => {
            
            console.log("button submitted")
            handleSubmitLost(2);

          }}
          disabled={submitBtnDisabled}
        >
          Submit
        </button>
        <button
          type="button"
          className={mainTable.cancelButton}
          onClick={() => handleCancel()}
        >
          Cancel
        </button>
      </div>
    </>
  );




};

export default OnLostPopUp;
